import { APP_CONFIG } from 'config/config';
import { apiFetchRaw } from 'lib/api';

// The original callbacks resolved to `{}` / `false` on a non-ok response
// instead of throwing, so each promise fn below catches the ApiError that
// apiFetchRaw throws and normalizes it back to that same fallback value.
export function fetchCurrentUserProfile() {
    return apiFetchRaw(APP_CONFIG.apiUrl + '/v1/profiles')
        .then((response) => response.json())
        .catch(() => ({}));
}
export function getCurrentUserProfile(callback) {
    fetchCurrentUserProfile().then(callback);
}

export function fetchUserProfile(userId) {
    return apiFetchRaw(APP_CONFIG.apiUrl + '/v1/profiles/' + userId)
        .then((response) => response.json())
        .catch(() => ({}));
}
export function getUserProfile(userId, callback) {
    fetchUserProfile(userId).then(callback);
}

export function updateProfile(formData) {
    return apiFetchRaw(APP_CONFIG.apiUrl + '/v1/profiles', {
        method: 'PUT',
        body: JSON.stringify(formData),
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(() => true)
        .catch(() => false);
}
export function putProfile(formData, callback) {
    updateProfile(formData).then(callback);
}
